<template>
<el-container>
  <el-header height="auto">
    <root-header></root-header>
  </el-header>
  <router-view></router-view>
  <root-footer></root-footer>
</el-container>
</template>

<script>
// @ is an alias to /src
import rootHeader from '@/components/index/RootHeader'
import rootFooter from '@/components/index/RootFooter'

export default {
  data () {
    return {
    }
  },
  components: {
    rootHeader,
    rootFooter
  }
}
</script>

<style lang="scss">
body {
  margin: 0px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
a {
  color: #4686f1;
  text-decoration: none;
}
.center-aligned {
  text-align: center;
}
.center-margin {
  margin: 0 auto;
}
.right-floated {
  float: right;
}
.container-con {
  max-width: 1200px;
  margin: 0 auto;
}
.inline-block {
  display: inline-block;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-header {
  z-index: 1;
  background-color: #000;
}
</style>
